{
  "title": "Sounds",
  "now": {
    "label": "Now playing",
    "playing": "Playing",
    "left": "Playing · {{time}} left",
    "readyTimer": "Ready · {{count}} min timer",
    "readyNoTimer": "Ready · no timer",
    "play": "Play {{sound}}",
    "pause": "Stop {{sound}}"
  },
  "library": {
    "label": "Sound library",
    "play": "Play {{sound}}",
    "stop": "Stop {{sound}}",
    "playing": "Playing",
    "chosen": "Chosen",
    "notes": {
      "shush": "Close to the steady whoosh your baby heard in the womb.",
      "white": "An even hiss that covers household noise.",
      "womb": "A muffled rumble with a slow, quiet heartbeat.",
      "heart": "A calm heartbeat at 70 beats a minute.",
      "hair": "A steady hum many babies settle to.",
      "fan": "Soft, low airflow.",
      "vacuum": "A loud, even rumble for hard crying spells.",
      "washer": "A slow tumble and a low swish.",
      "car": "The low engine rumble of a night drive.",
      "rain": "Light rain on a window.",
      "ocean": "Slow waves, about six a minute.",
      "music": "Brahms' Lullaby on a music box."
    },
    "short": {
      "shush": "The whoosh from the womb",
      "white": "An even hiss that hides house noise",
      "womb": "A muffled rumble and heartbeat",
      "heart": "Calm, 70 beats a minute",
      "hair": "A steady hum",
      "fan": "Soft, low airflow",
      "vacuum": "Loud and even, for hard crying",
      "washer": "A slow tumble",
      "car": "A night drive rumble",
      "rain": "Light rain on a window",
      "ocean": "Slow waves",
      "music": "Brahms' Lullaby"
    }
  },
  "timer": {
    "title": "Timer",
    "min": "{{count}} min",
    "minA11y": "{{count}} minutes",
    "off": "No timer",
    "offShort": "Off",
    "hint": "Fades out over the last 30 seconds."
  },
  "safety": "Keep the phone about 7 ft (2 m) from your baby. Moderate volume is enough, a little quieter than a normal conversation.",
  "entry": {
    "title": "Night mode",
    "body": "Listens for crying and starts {{sound}} by itself",
    "cta": "Start night mode",
    "link": "Night mode",
    "last": "Last time: {{cries}}, {{soothes}}",
    "cries_one": "{{count}} cry heard",
    "cries_other": "{{count}} cries heard",
    "soothes_one": "soothed once",
    "soothes_other": "soothed {{count}} times",
    "soothes_zero": "none soothed"
  },
  "night": {
    "title": "Night mode",
    "exit": "Exit",
    "exitA11y": "Exit night mode",
    "baby": "your baby",
    "intro": {
      "lead": "Baby Plan listens for crying and starts {{sound}} by itself.",
      "screen": "Keep this screen open all night. The phone can only listen while the screen is on, so it stays on, dimmed.",
      "charger": "Put the phone on a charger, about 7 ft (2 m) from the crib.",
      "private": "Listening happens on this phone. Nothing is recorded or sent.",
      "start": "Start listening",
      "starting": "Asking for the microphone…"
    },
    "loading": "Getting the listener ready · {{pct}}%",
    "loadingNote": "First time only: about 16 MB, then it works offline.",
    "status": {
      "quiet": "Listening for {{name}}",
      "quietSub": "{{sound}} starts when crying starts",
      "crying": "Crying heard · {{sound}} is on",
      "cryingSub": "Every minute the sound pauses for 3 seconds to listen",
      "checking": "Listening in the pause…",
      "calmer": "Sounds calmer · {{count}} of 3 quiet checks",
      "settling": "{{name}} settled · {{sound}} is fading out",
      "settlingSub": "If crying starts again, the sound comes back",
      "manual": "{{sound}} is on",
      "manualSub": "Listening continues. Night mode won't stop a sound you started.",
      "held": "Sound stopped",
      "heldSub": "Listening again in a moment",
      "paused": "Listening paused",
      "pausedSub": "The microphone stopped. Keep this screen open and unlocked."
    },
    "announce": {
      "listening": "Night mode is listening",
      "cry": "Crying heard. {{sound}} started.",
      "calm": "Crying stopped. The sound is fading out.",
      "paused": "Listening paused"
    },
    "level": "Microphone level",
    "tonight": {
      "title": "Tonight",
      "cries_one": "{{count}} cry heard",
      "cries_other": "{{count}} cries heard",
      "soothes_one": "soothed once",
      "soothes_other": "soothed {{count}} times",
      "soothes_zero": "none soothed yet",
      "listening": "listening {{time}}",
      "eventCry": "Crying heard, sound on",
      "eventCalm": "Settled, sound faded out",
      "empty": "Nothing yet. Sleep well."
    },
    "play": "Play {{sound}}",
    "stop": "Stop sound",
    "settings": "Sound, timer and sensitivity",
    "keep": "Phone on the charger, screen dim and on. Nothing is recorded.",
    "wake": {
      "unsupported": "This phone may lock the screen by itself. Set Auto-Lock to Never while night mode is on.",
      "off": "The screen may turn off. Tap to keep it on."
    },
    "dim": "Tap to brighten",
    "sheet": {
      "title": "Night mode",
      "done": "Done",
      "sound": "Sound",
      "soundHint": "Plays when crying starts. Choosing here doesn't start it.",
      "timer": "Timer",
      "timerHint": "Restarts while crying is still heard.",
      "sensitivity": "Sensitivity"
    },
    "sensitivity": {
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "hint_low": "Fewer false starts. Pick it if the sound starts by itself.",
      "hint_medium": "Recommended for most rooms.",
      "hint_high": "Hears quieter or farther crying, but pets and laughter may start it too."
    },
    "errors": {
      "title": "Can't listen yet",
      "insecure": "Night mode needs a secure connection. Open Baby Plan from its app icon or its https address.",
      "unsupported": "This browser can't listen through the microphone. Open Baby Plan in Safari or Chrome.",
      "denied": "Baby Plan isn't allowed to use the microphone. Allow it in your phone's settings (Safari or Chrome › Microphone), then try again.",
      "no_mic": "No microphone was found on this device.",
      "busy": "Another app is using the microphone. Close it, then try again.",
      "error": "The microphone didn't start. Try again.",
      "model": "Couldn't get the listener ready. Check your internet connection and try again.",
      "retry": "Try again"
    },
    "titleName": "Night mode · {{name}}",
    "exitHold": "Hold to exit",
    "exitNudge": "Hold 1 second",
    "exitHolding": "Keep holding…",
    "exitHoldA11y": "Exit night mode. Touch and hold",
    "fades": "fades out in {{time}}",
    "orbPlay": "Play {{sound}}",
    "orbStop": "Stop {{sound}}"
  },
  "back": "Back",
  "cats": {
    "label": "Categories",
    "all": "All",
    "womb": "Womb",
    "noise": "Noise",
    "nature": "Nature",
    "lullaby": "Lullaby"
  },
  "sheet": {
    "title": "Sounds",
    "timerTitle": "Sound timer", "timerLead": "When should {{sound}} stop? It fades out gently.",
    "done": "Done",
    "sound": "Sound",
    "timer": "Timer",
    "hint": "Tap to listen. Closing stops it; the big button plays your choice.",
    "hintFelt": "Tap to listen. Closing stops it; the Shhh button plays your choice.",
    "safety": "Keep the phone about 7 ft (2 m) from your baby and the volume moderate."
  }
}
